import React from 'react';
import i18next from 'i18next';
import _ from 'lodash';
import {
  ActivityLevel,
  AttributeType,
  DocumentTypePropertyType,
  EDGE_DATE_FORMAT,
  FieldDisplayVariant,
  FieldType,
  Operator,
  statusEngCode,
  ThirdpartyScoreType,
} from './Constants';
import { find } from 'lodash';
import { InduedAllScores } from './InduedUtils';
import moment from 'moment';
import { CalculationResultType } from './CalculatorUtils';
import {
  getEsgScoresForRulesAndCalculations,
  ESG_SCORES_THEMES,
  generateEsgScoresTopics,
  getEsgDepths,
} from './DataBlocksUtils';
import { EvAllScores, EVAllScorePerfomance } from './EcovadisUtils';
import { getPrefixedSecurityRatingScore, SecurityRatingAllScoresEnum, SecurityRatingGlobalScoreMaturityEnum, SecurityRatingPerformanceEnum } from "./SecurityRatingUtils";
import { CreditsafeEnumForRules, getCreditsafeOptionsDependingOnScore } from './CreditsafeUtils';
import {getCountries} from "./Utils";
export const RULE_NAME_MAX_LENGTH = 100;

export const RulesContext = React.createContext({
  dossierTypes: [],
  actionTypes: [],
  documentTypes: [],
  activities: [],
  countries: [],
  thirdpartyAttributes: [],
  dossierAttributes: [],
  calculatedAttributes: [],
  thirdPartyIndicators: [],
  sourceData: [],
  financialStrengthScores: [],
  financialStrengthRatings: [],
  creditsafeScores: [],
  showInduedScores: false,
  showTransparencyScore: false,
  showSourceData: false,
  showFinancialStrengthScores: false,
  enableTransparencyScore: false,
  showEcovadisScores: false,
  showSecurityRatingScores: false,
  showCreditsafeScores: false,
  contextModels: [],
});

export const RuleType = {
  ON_THIRD_PARTY: 'ON_THIRD_PARTY',
  ON_DOSSIER: 'ON_DOSSIER',
  ON_CONTEXT: 'ON_CONTEXT',
  ON_CONTEXT_THIRD_PARTY: 'ON_CONTEXT_THIRD_PARTY',
  ON_DOCUMENT: 'ON_DOCUMENT'
};

export const getRuleTypeOptions = () => {
  return [
    {
      value: RuleType.ON_THIRD_PARTY,
      label: i18next.t('rules.configuration.type.thirdParty'),
    },
    {
      value: RuleType.ON_DOSSIER,
      label: i18next.t('rules.configuration.type.dossier'),
    },
    /*    {
          value: RuleType.ON_CONTEXT,
          label: i18next.t('rules.configuration.type.context'),
        },*/
    {
      value: RuleType.ON_CONTEXT_THIRD_PARTY,
      label: i18next.t('rules.configuration.type.contextThirdParty'),
    },
    {
      value: RuleType.ON_DOCUMENT,
      label: i18next.t('rules.configuration.type.document'),
    }
  ];
};

export const TargetFieldCategory = {
  THIRD_PARTY: 'THIRD_PARTY',
  DOSSIER: 'DOSSIER',
  DOCUMENT: 'DOCUMENT',
  CONTEXT: 'CONTEXT',
};

export const TargetFieldNature = {
  ENTITY_FIELD: 'ENTITY_FIELD',
  ATTRIBUTE: 'ATTRIBUTE',
  INDICATOR: 'INDICATOR',
  STATUS: 'STATUS',
  SCORE: 'SCORE',
  SOURCE_DATA: 'SOURCE_DATA',
  CONTEXT_ATTRIBUTE: 'CONTEXT_ATTRIBUTE',
  CONTEXT_TIERS_ATTRIBUTE: 'CONTEXT_TIERS_ATTRIBUTE',
  CONTEXT_DECLARANT_ATTRIBUTE: 'CONTEXT_DECLARANT_ATTRIBUTE',
  CONTEXT_RANK: 'CONTEXT_RANK',
  USER_INSTANCE: 'USER_INSTANCE'
};

export const getTargetFieldCategoryOptions = (ruleType) => {
  let targetFieldCategoryOptions = [];
  switch (ruleType) {
    case RuleType.ON_THIRD_PARTY:
      targetFieldCategoryOptions = [
        {
          value: TargetFieldCategory.THIRD_PARTY,
          label: i18next.t(
            `rules.configuration.criteria.targetFieldCategory.${TargetFieldCategory.THIRD_PARTY}`
          ),
          icon: 'thirdparty_green',
        },
        {
          value: TargetFieldCategory.DOSSIER,
          label: i18next.t(
            `rules.configuration.criteria.targetFieldCategory.${TargetFieldCategory.DOSSIER}`
          ),
          icon: 'folder_open',
        },
        {
          value: TargetFieldCategory.DOCUMENT,
          label: i18next.t(
            `rules.configuration.criteria.targetFieldCategory.${TargetFieldCategory.DOCUMENT}`
          ),
          icon: 'document',
        },
        {
          value: TargetFieldCategory.CONTEXT,
          label: i18next.t(
            `rules.configuration.criteria.targetFieldCategory.${TargetFieldCategory.CONTEXT}`
          ),
          icon: 'context/business_center',
        },
      ];
      break;

    case RuleType.ON_DOSSIER:
      targetFieldCategoryOptions = [
        {
          value: TargetFieldCategory.THIRD_PARTY,
          label: i18next.t(
            `rules.configuration.criteria.targetFieldCategory.${TargetFieldCategory.THIRD_PARTY}`
          ),
          icon: 'thirdparty_green',
        },
        {
          value: TargetFieldCategory.DOSSIER,
          label: i18next.t(
            `rules.configuration.criteria.targetFieldCategory.${TargetFieldCategory.DOSSIER}`
          ),
          icon: 'folder_open',
        },
        {
          value: TargetFieldCategory.DOCUMENT,
          label: i18next.t(
            `rules.configuration.criteria.targetFieldCategory.${TargetFieldCategory.DOCUMENT}`
          ),
          icon: 'document',
        },
        {
          value: TargetFieldCategory.CONTEXT,
          label: i18next.t(
            `rules.configuration.criteria.targetFieldCategory.${TargetFieldCategory.CONTEXT}`
          ),
          icon: 'context/business_center',
        },
      ];
      break;

    case RuleType.ON_CONTEXT:
      targetFieldCategoryOptions = [
        {
          value: TargetFieldCategory.THIRD_PARTY,
          label: i18next.t(
            `rules.configuration.criteria.targetFieldCategory.${TargetFieldCategory.THIRD_PARTY}`
          ),
          icon: 'thirdparty_green',
        },
        {
          value: TargetFieldCategory.DOSSIER,
          label: i18next.t(
            `rules.configuration.criteria.targetFieldCategory.${TargetFieldCategory.DOSSIER}`
          ),
          icon: 'folder_open',
        },
        {
          value: TargetFieldCategory.DOCUMENT,
          label: i18next.t(
            `rules.configuration.criteria.targetFieldCategory.${TargetFieldCategory.DOCUMENT}`
          ),
          icon: 'document',
        },
        {
          value: TargetFieldCategory.CONTEXT,
          label: i18next.t(
            `rules.configuration.criteria.targetFieldCategory.${TargetFieldCategory.CONTEXT}`
          ),
          icon: 'context/business_center',
        },
      ];
      break;
    case RuleType.ON_CONTEXT_THIRD_PARTY:
      targetFieldCategoryOptions = [
        {
          value: TargetFieldCategory.THIRD_PARTY,
          label: i18next.t(
            `rules.configuration.criteria.targetFieldCategory.${TargetFieldCategory.THIRD_PARTY}`
          ),
          icon: 'thirdparty_green',
        },
        {
          value: TargetFieldCategory.DOSSIER,
          label: i18next.t(
            `rules.configuration.criteria.targetFieldCategory.${TargetFieldCategory.DOSSIER}`
          ),
          icon: 'folder_open',
        },
        {
          value: TargetFieldCategory.DOCUMENT,
          label: i18next.t(
            `rules.configuration.criteria.targetFieldCategory.${TargetFieldCategory.DOCUMENT}`
          ),
          icon: 'document',
        },
        {
          value: TargetFieldCategory.CONTEXT,
          label: i18next.t(
            `rules.configuration.criteria.targetFieldCategory.${TargetFieldCategory.CONTEXT}`
          ),
          icon: 'context/business_center',
        },
      ];
      break;

    case RuleType.ON_DOCUMENT:
    targetFieldCategoryOptions = [
        {
          value: TargetFieldCategory.THIRD_PARTY,
          label: i18next.t(
            `rules.configuration.criteria.targetFieldCategory.${TargetFieldCategory.THIRD_PARTY}`
          ),
          icon: 'thirdparty_green',
        },
        {
          value: TargetFieldCategory.DOSSIER,
          label: i18next.t(
            `rules.configuration.criteria.targetFieldCategory.${TargetFieldCategory.DOSSIER}`
          ),
          icon: 'folder_open',
        },
        {
          value: TargetFieldCategory.DOCUMENT,
          label: i18next.t(
            `rules.configuration.criteria.targetFieldCategory.${TargetFieldCategory.DOCUMENT}`
          ),
          icon: 'document',
        },
        {
          value: TargetFieldCategory.CONTEXT,
          label: i18next.t(
            `rules.configuration.criteria.targetFieldCategory.${TargetFieldCategory.CONTEXT}`
          ),
          icon: 'context/business_center',
        },
      ];
      break;
    default:
      break;
  }

  return targetFieldCategoryOptions;
};

export const RuleFormSteps = {
  CONFIGURATION: 'CONFIGURATION',
  ACTION: 'ACTION',
  SUMMARY: 'SUMMARY',
  FINALIZATION: 'FINALIZATION',
};

export const RuleActionType = {
  DOSSIER_CREATION: 'DOSSIER_CREATION',
  DOSSIER_STOP: 'DOSSIER_STOP',
  FINANCIAL_STRENGTH_ACTIVATION: 'FINANCIAL_STRENGTH_ACTIVATION',
  FINANCIAL_STRENGTH_DEACTIVATION: 'FINANCIAL_STRENGTH_DEACTIVATION',
  DNB_ESG_ACTIVATION: 'DNB_ESG_ACTIVATION',
  DNB_ESG_DEACTIVATION: 'DNB_ESG_DEACTIVATION',
  CREDITSAFE_SCORE_ACTIVATION: 'CREDITSAFE_SCORE_ACTIVATION',
  CREDITSAFE_SCORE_DEACTIVATION: 'CREDITSAFE_SCORE_DEACTIVATION',
  DOCUMENT_ADD: 'DOCUMENT_ADD',
  DOCUMENT_REMOVE: 'DOCUMENT_REMOVE',
  THIRD_PARTY_STOP: 'THIRD_PARTY_STOP',
  ADD_THIRD_PARTY_TO_CONTEXT: 'ADD_THIRD_PARTY_TO_CONTEXT',
  ARCHIVE_THIRD_PARTY_FROM_CONTEXT: 'ARCHIVE_THIRD_PARTY_FROM_CONTEXT',
  ARCHIVE_CONTEXT: 'ARCHIVE_CONTEXT',
  ACTIVATE_CONTEXT: 'ACTIVATE_CONTEXT',
  ADD_DOSSIER_CONTEXT: "ADD_DOSSIER_CONTEXT",
  ARCHIVE_DOSSIER_CONTEXT: "ARCHIVE_DOSSIER_CONTEXT",
  ARCHIVE_CONTEXT_THIRDPARTY: 'ARCHIVE_CONTEXT_THIRDPARTY',
  ACTIVATE_CONTEXT_THIRDPARTY: 'ACTIVATE_CONTEXT_THIRDPARTY',
  ADD_DOSSIER_CONTEXT_THIRDPARTY: "ADD_DOSSIER_CONTEXT_THIRDPARTY",
  ARCHIVE_DOSSIER_CONTEXT_THIRDPARTY: "ARCHIVE_DOSSIER_CONTEXT_THIRDPARTY",
  DOSSIER_TYPE_CHANGE: "DOSSIER_TYPE_CHANGE",
  DOCUMENT_STATUS_CHANGE: 'DOCUMENT_STATUS_CHANGE'
};

export const RuleActionParameterNames = {
  DOSSIER_TYPE_CODE: 'dossier_param_type_code',
  DOSSIER_REFERENCE: 'dossier_param_reference',
  DOSSIER_REACTIVATE_ARCHIVED: 'dossier_param_reactivate_archived',
  DOCUMENT_TYPE_IDS: 'document_param_type_ids',
  CONTEXT_MODEL_ID: 'context_model_id',
  DOSSIER_TYPE_CHANGE_OPTION: 'dossier_param_dossier_type_change_option',
  REVERSE_ACTION_EXECUTION_ACTIVATED: 'shared_param_reverse_action_execution_activated',
  DOCUMENT_STATUS_CODE: 'document_param_status_code'
};


export const RuleActionParameterOptions = [
  {
    value: 'DOSSIER_TYPE_CHANGE_OPTION_ADD_MISSING_DOCS',
    label: 'OPTION_ADD_MISSING_DOCS'
  },
  {
    value: 'DOSSIER_TYPE_CHANGE_OPTION_REPLACE_ALL_DOCS',
    label: 'OPTION_REPLACE_ALL_DOCS'
  },
  {
    value: 'DOSSIER_TYPE_CHANGE_OPTION_IGNORE_DOCS',
    label: 'OPTION_IGNORE_DOCS'
  }
];

export const getCriterionModel = () => {
  return {
    id: '',
    targetField: '',
    operator: '',
    values: [],
  };
};

export const getRuleActionModel = () => {
  return {
    id: '',
    type: '',
    parameters: {},
    ruleId: '',
  };
};

export const getRuleActionTypes = () => {
  return [
    {
      value: RuleActionType.DOSSIER_CREATION,
      label: i18next.t(`rules.configuration.ruleActions.types.DOSSIER_CREATION`),
      target: RuleType.ON_THIRD_PARTY
    },
    {
      value: RuleActionType.DOSSIER_STOP,
      label: i18next.t(`rules.configuration.ruleActions.types.DOSSIER_STOP`),
      target: RuleType.ON_THIRD_PARTY
    },
    {
      value: RuleActionType.FINANCIAL_STRENGTH_ACTIVATION,
      label: i18next.t(`rules.configuration.ruleActions.types.FINANCIAL_STRENGTH_ACTIVATION`),
      target: RuleType.ON_THIRD_PARTY
    },
    {
      value: RuleActionType.FINANCIAL_STRENGTH_DEACTIVATION,
      label: i18next.t(`rules.configuration.ruleActions.types.FINANCIAL_STRENGTH_DEACTIVATION`),
      target: RuleType.ON_THIRD_PARTY
    },
    {
      value: RuleActionType.DNB_ESG_ACTIVATION,
      label: i18next.t(`rules.configuration.ruleActions.types.DNB_ESG_ACTIVATION`),
      target: RuleType.ON_THIRD_PARTY
    },
    {
      value: RuleActionType.DNB_ESG_DEACTIVATION,
      label: i18next.t(`rules.configuration.ruleActions.types.DNB_ESG_DEACTIVATION`),
      target: RuleType.ON_THIRD_PARTY
    },
    {
      value: RuleActionType.CREDITSAFE_SCORE_ACTIVATION,
      label: i18next.t(`rules.configuration.ruleActions.types.CREDITSAFE_SCORE_ACTIVATION`),
      target: RuleType.ON_THIRD_PARTY
    },
    {
      value: RuleActionType.CREDITSAFE_SCORE_DEACTIVATION,
      label: i18next.t(`rules.configuration.ruleActions.types.CREDITSAFE_SCORE_DEACTIVATION`),
      target: RuleType.ON_THIRD_PARTY
    },
    {
      value: RuleActionType.DOCUMENT_ADD,
      label: i18next.t(`rules.configuration.ruleActions.types.DOCUMENT_ADD`),
      target: RuleType.ON_DOSSIER
    },
    {
      value: RuleActionType.DOCUMENT_REMOVE,
      label: i18next.t(`rules.configuration.ruleActions.types.DOCUMENT_REMOVE`),
      target: RuleType.ON_DOSSIER
    },
    {
      value: RuleActionType.THIRD_PARTY_STOP,
      label: i18next.t(
        `rules.configuration.ruleActions.types.THIRD_PARTY_STOP`
      ),
      target: RuleType.ON_THIRD_PARTY,
    },
    {
      value: RuleActionType.ADD_THIRD_PARTY_TO_CONTEXT,
      label: i18next.t(
        `rules.configuration.ruleActions.types.ADD_THIRD_PARTY_TO_CONTEXT`
      ),
      target: RuleType.ON_THIRD_PARTY,
    },
    {
      value: RuleActionType.ARCHIVE_THIRD_PARTY_FROM_CONTEXT,
      label: i18next.t(
        `rules.configuration.ruleActions.types.ARCHIVE_THIRD_PARTY_FROM_CONTEXT`
      ),
      target: RuleType.ON_THIRD_PARTY,
    },
    {
      value: RuleActionType.ARCHIVE_CONTEXT,
      label: i18next.t(
        `rules.configuration.ruleActions.types.ARCHIVE_CONTEXT`
      ),
      target: RuleType.ON_CONTEXT,
    },
    {
      value: RuleActionType.ACTIVATE_CONTEXT,
      label: i18next.t(
        `rules.configuration.ruleActions.types.ACTIVATE_CONTEXT`
      ),
      target: RuleType.ON_CONTEXT,
    },
    {
      value: RuleActionType.ADD_DOSSIER_CONTEXT,
      label: i18next.t(
        `rules.configuration.ruleActions.types.ADD_DOSSIER_CONTEXT`
      ),
      target: RuleType.ON_CONTEXT,
    },
    {
      value: RuleActionType.ARCHIVE_DOSSIER_CONTEXT,
      label: i18next.t(
        `rules.configuration.ruleActions.types.ARCHIVE_DOSSIER_CONTEXT`
      ),
      target: RuleType.ON_CONTEXT,
    },
    {
      value: RuleActionType.ARCHIVE_CONTEXT_THIRDPARTY,
      label: i18next.t(
        `rules.configuration.ruleActions.types.ARCHIVE_CONTEXT_THIRDPARTY`
      ),
      target: RuleType.ON_CONTEXT_THIRD_PARTY,
    },
    {
      value: RuleActionType.ACTIVATE_CONTEXT_THIRDPARTY,
      label: i18next.t(
        `rules.configuration.ruleActions.types.ACTIVATE_CONTEXT_THIRDPARTY`
      ),
      target: RuleType.ON_CONTEXT_THIRD_PARTY,
    },
    {
      value: RuleActionType.ADD_DOSSIER_CONTEXT_THIRDPARTY,
      label: i18next.t(
        `rules.configuration.ruleActions.types.ADD_DOSSIER_CONTEXT_THIRDPARTY`
      ),
      target: RuleType.ON_CONTEXT_THIRD_PARTY,
    },
    {
      value: RuleActionType.ARCHIVE_DOSSIER_CONTEXT_THIRDPARTY,
      label: i18next.t(
        `rules.configuration.ruleActions.types.ARCHIVE_DOSSIER_CONTEXT_THIRDPARTY`
      ),
      target: RuleType.ON_CONTEXT_THIRD_PARTY,
    },
    {
      value: RuleActionType.DOSSIER_TYPE_CHANGE,
      label: i18next.t(`rules.configuration.ruleActions.types.DOSSIER_TYPE_CHANGE`),
      target: RuleType.ON_DOSSIER
    },
    {
      value: RuleActionType.DOCUMENT_STATUS_CHANGE,
      label: i18next.t(
        `rules.configuration.ruleActions.types.DOCUMENT_STATUS_CHANGE`
      ),
      target: RuleType.ON_DOCUMENT,
    },
  ];
};

export const validateRule = (actions) => {
  if (_.isEmpty(actions)) {
    return "no-actions";
  }

  if (actions?.filter((x) => x.dossierTypeCode !== "" && x.dossierReference === "").length > 0) {
    return "no-refs";
  }

  if (actions?.filter((x) => x.dossierTypeCode !== "" && x.dossierReference !== "").length === 0) {
    return "no-dossier"
  }
  if (actions?.filter((x) => x.type?.includes("FINANCIAL_STRENGTH")).length > 1) {
    return "multiple-actions-not-allowed"
  }
}

export const isExistingRuleToActivateHaveErrors = (actions) => {
  return _.isEmpty(actions) ||
    /* CASE DOSSIER_CREATION */
    (actions?.filter((action) => action.type === RuleActionType.DOSSIER_CREATION &&
      (!action.parameters[`${RuleActionParameterNames.DOSSIER_REFERENCE}`] || !action.parameters[`${RuleActionParameterNames.DOSSIER_TYPE_CODE}`])).length > 0) ||
    /* CASE SCORE SANTE FINANCIERE */
    actions?.filter((action) => action.type?.includes("FINANCIAL_STRENGTH")).length > 1
}

export const isActionsWithWarning = (actions, dossierTypes) => {
  const dossiersTypesWithWarnings = dossierTypes?.filter(dt => dt.requirements?.some(req => req.code === 'RDCI'))
  return actions?.some(action =>
    action.type === RuleActionType.DOSSIER_CREATION &&
    dossiersTypesWithWarnings?.some(dt => dt.code === action.parameters?.dossier_param_type_code)
  ) || false;
}


export const getTargetFieldOptionsForThirdParty = (
  {
    countries = [],
    activities = [],
    thirdpartyAttributes = [],
    calculatedAttributes = [],
    indicators = [],
    sourceData = [],
    financialStrengthScores = [],
    financialStrengthRatings = [],
    withInduedScores = false,
    withTransparencyScore = false,
    withSourceData = false,
    withFinancialStrengthScores = false,
    withEsgScores = false,
    enableTransparencyScore = false,
    withEcovadisScores = false,
    withSecurityRatingScores = false,
    withCreditsafeScores = false,
    lang = 'en'
  }
) => {
  thirdpartyAttributes = thirdpartyAttributes.sort((a, b) => a.label.localeCompare(b.label));
  indicators = indicators.sort((a, b) => a.label.localeCompare(b.label));

  const esgScoresTopics = generateEsgScoresTopics();

  return [
    {
      value: 'name',
      label: i18next.t("rules.targetOption.thirdParties"),
      type: FieldType.TEXT,
      valueOptions: [],
      fieldNature: TargetFieldNature.ENTITY_FIELD,
    },
    {
      value: 'third_party_code',
      label: i18next.t("rules.targetOption.thirdPartyCode"),
      type: FieldType.TEXT,
      valueOptions: [],
      fieldNature: TargetFieldNature.ENTITY_FIELD,
    },
    {
      value: 'etab_activity_sic_major',
      label: i18next.t("rules.targetOption.activitySicMajor"),
      type: FieldType.ACTIVITY,
      valueOptions: activities.filter(activity => activity.level === ActivityLevel.SIC_MAJOR),
      fieldNature: TargetFieldNature.ENTITY_FIELD,
      optionsDisplayVariant: FieldDisplayVariant.AUTOCOMPLETE
    },
    {
      value: 'etab_activity_sic_2',
      label: i18next.t("rules.targetOption.activitySic", { number: 2 }),
      type: FieldType.ACTIVITY,
      valueOptions: activities.filter(activity => activity.level === ActivityLevel.SIC_2_DIGITS),
      fieldNature: TargetFieldNature.ENTITY_FIELD,
      optionsDisplayVariant: FieldDisplayVariant.AUTOCOMPLETE
    },
    {
      value: 'etab_activity_sic_3',
      label: i18next.t("rules.targetOption.activitySic", { number: 3 }),
      type: FieldType.ACTIVITY,
      valueOptions: activities.filter(activity => activity.level === ActivityLevel.SIC_3_DIGITS),
      fieldNature: TargetFieldNature.ENTITY_FIELD,
      optionsDisplayVariant: FieldDisplayVariant.AUTOCOMPLETE
    },
    {
      value: 'etab_activity_sic_4',
      label: i18next.t("rules.targetOption.activitySic", { number: 4 }),
      type: FieldType.ACTIVITY,
      valueOptions: activities.filter(activity => activity.level === ActivityLevel.SIC_4_DIGITS),
      fieldNature: TargetFieldNature.ENTITY_FIELD,
      optionsDisplayVariant: FieldDisplayVariant.AUTOCOMPLETE
    },
    {
      value: 'etab_activity_sic_6',
      label: i18next.t("rules.targetOption.activitySic", { number: 6 }),
      type: FieldType.ACTIVITY,
      valueOptions: activities.filter(activity => activity.level === ActivityLevel.SIC_6_DIGITS),
      fieldNature: TargetFieldNature.ENTITY_FIELD,
      optionsDisplayVariant: FieldDisplayVariant.AUTOCOMPLETE
    },
    {
      value: 'etab_activity_sic_8',
      label: i18next.t("rules.targetOption.activitySic", { number: 8 }),
      type: FieldType.ACTIVITY,
      valueOptions: activities.filter(activity => activity.level === ActivityLevel.SIC_8_DIGITS),
      fieldNature: TargetFieldNature.ENTITY_FIELD,
      optionsDisplayVariant: FieldDisplayVariant.AUTOCOMPLETE
    },
    {
      value: 'headquarter',
      label: i18next.t("rules.targetOption.headquarters"),
      type: FieldType.CUSTOM,
      valueOptions: [
        {
          value: 'true',
          label: i18next.t("headquarters")
        },
        {
          value: 'false',
          label: i18next.t("secondaryBranch")
        },
      ],
      fieldNature: TargetFieldNature.ENTITY_FIELD,
    },
    {
      value: 'address_post_code',
      label: i18next.t("rules.targetOption.postalCode"),
      type: FieldType.TEXT,
      valueOptions: [],
      fieldNature: TargetFieldNature.ENTITY_FIELD,
    },
    {
      value: 'address_city',
      label: i18next.t("rules.targetOption.city"),
      type: FieldType.TEXT,
      valueOptions: [],
      fieldNature: TargetFieldNature.ENTITY_FIELD,
    },
    {
      value: 'address_country_code',
      label: i18next.t("rules.targetOption.country"),
      type: FieldType.CUSTOM,
      valueOptions: countries,
      fieldNature: TargetFieldNature.ENTITY_FIELD,
    },
    {
      value: 'brandName',
      label: i18next.t("rules.targetOption.brandName"),
      type: FieldType.TEXT,
      valueOptions: [],
      fieldNature: TargetFieldNature.ENTITY_FIELD,
    },
    {
      value: 'without_active_dossier',
      label: i18next.t("rules.targetOption.withoutActiveDossier"),
      type: FieldType.CUSTOM,
      valueOptions: [
        {
          value: 'true',
          label: i18next.t("yes")
        },
        {
          value: 'false',
          label: i18next.t("no")
        },
      ],
      fieldNature: TargetFieldNature.USER_INSTANCE,
    },
    {
      value: 'with_contact',
      label: i18next.t("rules.targetOption.thirdPartyWithContact"),
      type: FieldType.CUSTOM,
      valueOptions: [
        {
          value: 'true',
          label: i18next.t("yes")
        },
        {
          value: 'false',
          label: i18next.t("no")
        },
      ],
      fieldNature: TargetFieldNature.USER_INSTANCE,
    },
    ...thirdpartyAttributes?.filter((attr) => { return ![AttributeType.STRING].includes(attr.type); })?.map((attr) => {
      return {
        value: `${attr.id}`,
        label: attr.label,
        type: FieldType.ATTRIBUTE,
        subType: attr.type,
        dt: true,
        /*
          A boolean attribute doesn't have predefined value options on the backend side,
          but it's a primitive type that has limited options (true and false), so process
          it differently
        */
        valueOptions: (AttributeType.BOOLEAN === attr.type) ? [
          {
            value: "true",
            label: i18next.t("yes")
          },
          {
            value: "false",
            label: i18next.t("no")
          },
        ] : attr.values?.map((valueEntry) => {
          return {
            value: valueEntry.value,
            label: valueEntry.value
          }
        }) || [],
        fieldNature: TargetFieldNature.ATTRIBUTE,
      };
    }),
    ...calculatedAttributes?.map((calculatedAttr) => {
      return {
        value: `${calculatedAttr.value}`,
        label: calculatedAttr.label,
        type: FieldType.CALCULATED_ATTRIBUTE,
        subType: calculatedAttr.type,
        valueOptions: [],
        fieldNature: TargetFieldNature.ATTRIBUTE,
        dt: true,
      };
    }),
    ...indicators?.map((ind) => {
      return {
        value: `${ind.value}`,
        label: ind.label,
        type: FieldType.INDICATOR,
        subType: ind.type,
        valueOptions: [],
        fieldNature: TargetFieldNature.INDICATOR,
        dt: true,
      };
    }),
    ...(withInduedScores ?
      InduedAllScores.map(score => {
        return {
          value: score,
          label: i18next.t(`indued.scoresFull.${score}`),
          type: FieldType.RISK,
          valueOptions: [
            {
              value: "0",
              label: i18next.t("indued.severity.unknown")
            },
            {
              value: "1",
              label: i18next.t("indued.severity.low")
            },
            {
              value: "2",
              label: i18next.t("indued.severity.medium")
            },
            {
              value: "3",
              label: i18next.t("indued.severity.high")
            },
          ],
          fieldNature: TargetFieldNature.INDICATOR,
        };
      })
      :
      []),
    ...withSourceData ?
      mapSourceDataTargetFieldForRule(sourceData, lang) : [],
    ...(withTransparencyScore) ?
      [
        {
          value: "transparency_score",
          label: i18next.t("transparency.criterionLabel"),
          type: FieldType.NUMERIC,
          valueOptions: [],
          fieldNature: TargetFieldNature.INDICATOR,
          disabled: !enableTransparencyScore
        }
      ]
      :
      [],

    ...(withFinancialStrengthScores) ?
      [
        {
          value: "financial_strength_score",
          label: i18next.t("financialStrength.criteriaBuilderScoreLabel"),
          type: FieldType.RISK,
          subType: ThirdpartyScoreType.DATABLOCKS_FINANCIAL_STRENGTH,
          valueOptions: financialStrengthScores,
          fieldNature: TargetFieldNature.INDICATOR,
        },
        {
          value: "financial_strength_rating",
          label: i18next.t("financialStrength.criteriaBuilderRatingLabel"),
          type: FieldType.RISK,
          subType: ThirdpartyScoreType.DATABLOCKS_FINANCIAL_STRENGTH,
          valueOptions: financialStrengthRatings,
          fieldNature: TargetFieldNature.INDICATOR,
        }
      ]
      :
      [],

    ...(withEcovadisScores ?
      EvAllScores.map(score => {
        return {
          value: `ecovadis_${score}`,
          label: "Ecovadis " + i18next.t(`ecovadis.scores.${score}`),
          type: FieldType.RISK,
          valueOptions: Object.values(EVAllScorePerfomance).map(performance => ({
            value: performance.toUpperCase(),
            label: i18next.t(`ecovadis.performance.${performance}`)
          })),
          fieldNature: TargetFieldNature.INDICATOR,
        };
      })
      :
      []
    ),

    ...(withSecurityRatingScores ?
      Object.values(SecurityRatingAllScoresEnum).map(score => {
        let options;
        if (score === SecurityRatingAllScoresEnum.GLOBAL_SCORE) {
          options = Object.values(SecurityRatingGlobalScoreMaturityEnum).map(performance => ({
            value: performance?.toUpperCase(),
            label: i18next.t(`securityRating.maturity.${performance.toLowerCase()}`)
          }))
        } else {
          options = Object.values(SecurityRatingPerformanceEnum).map(performance => ({
            value: performance,
            label: performance
          }))
        }

        return {
          value: getPrefixedSecurityRatingScore(score),
          label: "Security Rating " + i18next.t(`securityRating.scores.${score}`),
          type: FieldType.RISK,
          subType: ThirdpartyScoreType.SECURITY_RATING,
          valueOptions: options,
          fieldNature: TargetFieldNature.INDICATOR,
        };
      })
      :
      []
    ),

    ...(withEsgScores) ?
      mapEsgScoreTargetFieldForRules([
        {
          value: "section_esg", subFields: mapEsgScoreTargetFieldForRules([
            { value: "esg_score", options: getEsgScoresForRulesAndCalculations(), path: ["section_esg", "esg_score"] },
            { value: "esg_depth", options: getEsgDepths(), path: ["section_esg", "esg_depth"] },
            {
              value: "section_esg_risk_environment", subFields: mapEsgScoreTargetFieldForRules([
                {
                  value: "esg_risk_environment",
                  options: getEsgScoresForRulesAndCalculations(),
                  path: ["section_esg", "section_esg_risk_environment", "esg_risk_environment"]
                },
                {
                  value: "section_esg_risk_environment_theme_emissions_climat", subFields: mapEsgScoreTargetFieldForRules([
                    {
                      value: "esg_risk_environment_theme_emissions_climat",
                      options: ESG_SCORES_THEMES,
                      path: ["section_esg", "section_esg_risk_environment", "section_esg_risk_environment_theme_emissions_climat", "esg_risk_environment_theme_emissions_climat"]
                    },
                    {
                      value: "esg_risk_environment_topic_climatic_risk",
                      options: esgScoresTopics,
                      path: ["section_esg", "section_esg_risk_environment", "section_esg_risk_environment_theme_emissions_climat", "esg_risk_environment_topic_climatic_risk"]
                    },
                    {
                      value: "esg_risk_environment_topic_ghg_emissions",
                      options: esgScoresTopics,
                      path: ["section_esg", "section_esg_risk_environment", "section_esg_risk_environment_theme_emissions_climat", "esg_risk_environment_topic_ghg_emissions"]
                    },
                  ], true)
                },
                {
                  value: "section_esg_risk_environment_theme_natural_ressources", subFields: mapEsgScoreTargetFieldForRules([
                    {
                      value: "esg_risk_environment_theme_natural_ressources",
                      options: ESG_SCORES_THEMES,
                      path: ["section_esg", "section_esg_risk_environment", "section_esg_risk_environment_theme_natural_ressources", "esg_risk_environment_theme_natural_ressources"]
                    },
                    {
                      value: "esg_risk_environment_topic_energy_management",
                      options: esgScoresTopics,
                      path: ["section_esg", "section_esg_risk_environment", "section_esg_risk_environment_theme_natural_ressources", "esg_risk_environment_theme_natural_ressources"]
                    },
                    {
                      value: "esg_risk_environment_topic_land_use_biodiversity",
                      options: esgScoresTopics,
                      path: ["section_esg", "section_esg_risk_environment", "section_esg_risk_environment_theme_natural_ressources", "esg_risk_environment_topic_land_use_biodiversity"]
                    },
                    {
                      value: "esg_risk_environment_topic_materials_sourcing",
                      options: esgScoresTopics,
                      path: ["section_esg", "section_esg_risk_environment", "section_esg_risk_environment_theme_natural_ressources", "esg_risk_environment_topic_materials_sourcing"]
                    },
                    {
                      value: "esg_risk_environment_topic_pollution_prevention",
                      options: esgScoresTopics,
                      path: ["section_esg", "section_esg_risk_environment", "section_esg_risk_environment_theme_natural_ressources", "esg_risk_environment_topic_pollution_prevention"]
                    },
                    {
                      value: "esg_risk_environment_topic_waste_hazards",
                      options: esgScoresTopics,
                      path: ["section_esg", "section_esg_risk_environment", "section_esg_risk_environment_theme_natural_ressources", "esg_risk_environment_topic_waste_hazards"]
                    },
                    {
                      value: "esg_risk_environment_topic_water_management",
                      options: esgScoresTopics,
                      path: ["section_esg", "section_esg_risk_environment", "section_esg_risk_environment_theme_natural_ressources", "esg_risk_environment_topic_water_management"]
                    }
                  ], true)
                },
                {
                  value: "section_esg_risk_environment_theme_opportunities", subFields: mapEsgScoreTargetFieldForRules([
                    {
                      value: "esg_risk_environment_theme_opportunities",
                      options: ESG_SCORES_THEMES,
                      path: ["section_esg", "section_esg_risk_environment", "section_esg_risk_environment_theme_opportunities", "esg_risk_environment_theme_opportunities"]
                    },
                    {
                      value: "esg_risk_environment_topic_certifications",
                      options: esgScoresTopics,
                      path: ["section_esg", "section_esg_risk_environment", "section_esg_risk_environment_theme_opportunities", "esg_risk_environment_topic_certifications"]
                    },
                    {
                      value: "esg_risk_environment_topic_opportunities",
                      options: esgScoresTopics,
                      path: ["section_esg", "section_esg_risk_environment", "section_esg_risk_environment_theme_opportunities", "esg_risk_environment_topic_opportunities"]
                    }
                  ], true)
                },
                {
                  value: "section_esg_risk_environment_theme_risks", subFields: mapEsgScoreTargetFieldForRules([
                    {
                      value: "esg_risk_environment_theme_risks",
                      options: ESG_SCORES_THEMES,
                      path: ["section_esg", "section_esg_risk_environment", "section_esg_risk_environment_theme_risks", "esg_risk_environment_theme_risks"]
                    },
                    {
                      value: "esg_risk_environment_topic_compliance",
                      options: esgScoresTopics,
                      path: ["section_esg", "section_esg_risk_environment", "section_esg_risk_environment_theme_risks", "esg_risk_environment_topic_compliance"]
                    }
                  ], true)
                },
              ])
            },
            {
              value: "section_esg_risk_social", subFields: mapEsgScoreTargetFieldForRules([
                {
                  value: "esg_risk_social",
                  options: getEsgScoresForRulesAndCalculations(),
                  path: ["section_esg", "section_esg_risk_social", "esg_risk_social"]
                },
                {
                  value: "section_esg_risk_social_theme_certifications", subFields: mapEsgScoreTargetFieldForRules([
                    {
                      value: "esg_risk_social_theme_certifications",
                      options: ESG_SCORES_THEMES,
                      path: ["section_esg", "section_esg_risk_social", "section_esg_risk_social_theme_certifications", "esg_risk_social_theme_certifications"]
                    },
                    {
                      value: "esg_risk_social_topic_certifications",
                      options: esgScoresTopics,
                      path: ["section_esg", "section_esg_risk_social", "section_esg_risk_social_theme_certifications", "esg_risk_social_topic_certifications"]
                    }
                  ], true)
                },
                {
                  value: "section_esg_risk_social_theme_community", subFields: mapEsgScoreTargetFieldForRules([
                    {
                      value: "esg_risk_social_theme_community",
                      options: ESG_SCORES_THEMES,
                      path: ["section_esg", "section_esg_risk_social", "section_esg_risk_social_theme_community", "esg_risk_social_theme_community"]
                    },
                    {
                      value: "esg_risk_social_topic_community_engagement",
                      options: esgScoresTopics,
                      path: ["section_esg", "section_esg_risk_social", "section_esg_risk_social_theme_community", "esg_risk_social_topic_community_engagement"]
                    },
                    {
                      value: "esg_risk_social_topic_corporate_philanthropy",
                      options: esgScoresTopics,
                      path: ["section_esg", "section_esg_risk_social", "section_esg_risk_social_theme_community", "esg_risk_social_topic_corporate_philanthropy"]
                    }
                  ], true)
                },
                {
                  value: "section_esg_risk_social_theme_customer_engagement", subFields: mapEsgScoreTargetFieldForRules([
                    {
                      value: "esg_risk_social_theme_customer_engagement",
                      options: ESG_SCORES_THEMES,
                      path: ["section_esg", "section_esg_risk_social", "section_esg_risk_social_theme_customer_engagement", "esg_risk_social_theme_customer_engagement"]
                    },
                    {
                      value: "esg_risk_social_topic_data_privacy",
                      options: esgScoresTopics,
                      path: ["section_esg", "section_esg_risk_social", "section_esg_risk_social_theme_customer_engagement", "esg_risk_social_topic_data_privacy"]
                    },
                    {
                      value: "esg_risk_social_topic_products_services",
                      options: esgScoresTopics,
                      path: ["section_esg", "section_esg_risk_social", "section_esg_risk_social_theme_customer_engagement", "esg_risk_social_topic_products_services"]
                    }
                  ], true)
                },
                {
                  value: "section_esg_risk_social_theme_human_capital", subFields: mapEsgScoreTargetFieldForRules([
                    {
                      value: "esg_risk_social_theme_human_capital",
                      options: ESG_SCORES_THEMES,
                      path: ["section_esg", "section_esg_risk_social", "section_esg_risk_social_theme_human_capital", "esg_risk_social_theme_human_capital"]
                    },
                    {
                      value: "esg_risk_social_topic_diversity_inclusion",
                      options: esgScoresTopics,
                      path: ["section_esg", "section_esg_risk_social", "section_esg_risk_social_theme_human_capital", "esg_risk_social_topic_diversity_inclusion"]
                    },
                    {
                      value: "esg_risk_social_topic_health_safety",
                      options: esgScoresTopics,
                      path: ["section_esg", "section_esg_risk_social", "section_esg_risk_social_theme_human_capital", "esg_risk_social_topic_health_safety"]
                    },
                    {
                      value: "esg_risk_social_topic_human_rights_abuses",
                      options: esgScoresTopics,
                      path: ["section_esg", "section_esg_risk_social", "section_esg_risk_social_theme_human_capital", "esg_risk_social_topic_human_rights_abuses"]
                    },
                    {
                      value: "esg_risk_social_topic_labor_relations",
                      options: esgScoresTopics,
                      path: ["section_esg", "section_esg_risk_social", "section_esg_risk_social_theme_human_capital", "esg_risk_social_topic_labor_relations"]
                    },
                    {
                      value: "esg_risk_social_topic_training_education",
                      options: esgScoresTopics,
                      path: ["section_esg", "section_esg_risk_social", "section_esg_risk_social_theme_human_capital", "esg_risk_social_topic_training_education"]
                    }
                  ], true)
                },
                {
                  value: "section_esg_risk_social_theme_products_services", subFields: mapEsgScoreTargetFieldForRules([
                    {
                      value: "esg_risk_social_theme_products_services",
                      options: ESG_SCORES_THEMES,
                      path: ["section_esg", "section_esg_risk_social", "section_esg_risk_social_theme_products_services", "esg_risk_social_theme_products_services"]
                    },
                    {
                      value: "esg_risk_social_topic_cyber_risk",
                      options: esgScoresTopics,
                      path: ["section_esg", "section_esg_risk_social", "section_esg_risk_social_theme_products_services", "esg_risk_social_topic_cyber_risk"]
                    },
                    {
                      value: "esg_risk_social_topic_product_quality",
                      options: esgScoresTopics,
                      path: ["section_esg", "section_esg_risk_social", "section_esg_risk_social_theme_products_services", "esg_risk_social_topic_product_quality"]
                    }
                  ], true)
                },
                {
                  value: "section_esg_risk_social_theme_supplier_engagement", subFields: mapEsgScoreTargetFieldForRules([
                    {
                      value: "esg_risk_social_theme_supplier_engagement",
                      options: ESG_SCORES_THEMES,
                      path: ["section_esg", "section_esg_risk_social", "section_esg_risk_social_theme_supplier_engagement", "esg_risk_social_theme_supplier_engagement"]
                    },
                    {
                      value: "esg_risk_social_topic_supplier_engagement",
                      options: esgScoresTopics,
                      path: ["section_esg", "section_esg_risk_social", "section_esg_risk_social_theme_supplier_engagement", "esg_risk_social_topic_supplier_engagement"]
                    },
                  ], true)
                }
              ])
            },
            {
              value: "section_esg_risk_governance", subFields: mapEsgScoreTargetFieldForRules([
                {
                  value: "esg_risk_governance",
                  options: getEsgScoresForRulesAndCalculations(),
                  path: ["section_esg", "section_esg_risk_governance", "esg_risk_governance"]
                },
                {
                  value: "section_esg_risk_governance_theme_business_resilience", subFields: mapEsgScoreTargetFieldForRules([
                    {
                      value: "esg_risk_governance_theme_business_resilience",
                      options: ESG_SCORES_THEMES,
                      path: ["section_esg", "section_esg_risk_governance", "section_esg_risk_governance_theme_business_resilience", "esg_risk_governance_theme_business_resilience"]
                    },
                    {
                      value: "esg_risk_governance_topic_business_resilience",
                      options: esgScoresTopics,
                      path: ["section_esg", "section_esg_risk_governance", "section_esg_risk_governance_theme_business_resilience", "esg_risk_governance_topic_business_resilience"]
                    }
                  ], true)
                },
                {
                  value: "section_esg_risk_governance_theme_corporate_behavior", subFields: mapEsgScoreTargetFieldForRules([
                    {
                      value: "esg_risk_governance_theme_corporate_behavior",
                      options: ESG_SCORES_THEMES,
                      path: ["section_esg", "section_esg_risk_governance", "section_esg_risk_governance_theme_corporate_behavior", "esg_risk_governance_theme_corporate_behavior"]
                    },
                    {
                      value: "esg_risk_governance_topic_corporate_compliance_behaviors",
                      options: esgScoresTopics,
                      path: ["section_esg", "section_esg_risk_governance", "section_esg_risk_governance_theme_corporate_behavior", "esg_risk_governance_topic_corporate_compliance_behaviors"]
                    },
                    {
                      value: "esg_risk_governance_topic_certifications",
                      options: esgScoresTopics,
                      path: ["section_esg", "section_esg_risk_governance", "section_esg_risk_governance_theme_corporate_behavior", "esg_risk_governance_topic_certifications"]
                    },
                  ], true)
                },
                {
                  value: "section_esg_risk_governance_theme_corporate_governance", subFields: mapEsgScoreTargetFieldForRules([
                    {
                      value: "esg_risk_governance_theme_corporate_governance",
                      options: ESG_SCORES_THEMES,
                      path: ["section_esg", "section_esg_risk_governance", "section_esg_risk_governance_theme_corporate_governance", "esg_risk_governance_theme_corporate_governance"]
                    },
                    {
                      value: "esg_risk_governance_topic_board_accountability",
                      options: esgScoresTopics,
                      path: ["section_esg", "section_esg_risk_governance", "section_esg_risk_governance_theme_corporate_governance", "esg_risk_governance_topic_board_accountability"]
                    },
                    {
                      value: "esg_risk_governance_topic_business_ethics",
                      options: esgScoresTopics,
                      path: ["section_esg", "section_esg_risk_governance", "section_esg_risk_governance_theme_corporate_governance", "esg_risk_governance_topic_business_ethics"]
                    },
                    {
                      value: "esg_risk_governance_topic_business_transparency",
                      options: esgScoresTopics,
                      path: ["section_esg", "section_esg_risk_governance", "section_esg_risk_governance_theme_corporate_governance", "esg_risk_governance_topic_business_transparency"]
                    },
                    {
                      value: "esg_risk_governance_topic_shareholder_rights",
                      options: esgScoresTopics,
                      path: ["section_esg", "section_esg_risk_governance", "section_esg_risk_governance_theme_corporate_governance", "esg_risk_governance_topic_shareholder_rights"]
                    }
                  ], true)
                }
              ])
            }
          ])
        },
      ])
      :
      [],

    ...(withCreditsafeScores ?
      Object.values(CreditsafeEnumForRules).map(score => {
        if (score === CreditsafeEnumForRules.PAYMENT_BEHAVIOR) {
          return {
            value:  "creditsafe_" + score,
            label: "Creditsafe " + i18next.t(`creditsafe.scores.${score}`),
            type: FieldType.RISK,
            subType: ThirdpartyScoreType.CREDITSAFE_NUMERIC,
            valueOptions: [],
            fieldNature: TargetFieldNature.INDICATOR,
            isNumeric: true
          };
        } else {
          let options = getCreditsafeOptionsDependingOnScore(score, false);

          return {
            value: "creditsafe_" + score,
            label: "Creditsafe " + i18next.t(`creditsafe.scores.${score}`),
            type: FieldType.RISK,
            subType: ThirdpartyScoreType.CREDITSAFE,
            valueOptions: options,
            fieldNature: TargetFieldNature.INDICATOR,
          };
        }
      })
      :
      []
    ),
  ];
}

const mapEsgScoreTargetFieldForRules = (array, isNumeric = false) => {
  return array.map((item) => {
    return {
      value: item.value,
      label: i18next.t(`ESG.field.${item.value}`),
      type: FieldType.RISK,
      subType: ThirdpartyScoreType.DATABLOCKS_ESG,
      valueOptions: item.options,
      subFields: item.subFields,
      fieldNature: TargetFieldNature.INDICATOR,
      path: item.path,
      isNumeric: isNumeric,
    };
  });
};

export const getFlatSubFieldsOptions = (array) => {
  const newArray = [...array];
  array.forEach((targetFieldOption) => {
    if (
      targetFieldOption.subFields &&
      Array.isArray(targetFieldOption.subFields)
    ) {
      targetFieldOption.subFields.forEach((subField) => {
        if (subField.subFields && Array.isArray(subField.subFields)) {
          const subarray = getFlatSubFieldsOptions(subField.subFields);
          subarray.forEach((subsubfield) => {
            newArray.push(subsubfield);
          });
        } else {
          newArray.push(subField);
        }
      });
    }
  });
  return newArray;
};

export const mapSourceDataTargetFieldForRule = (array, lang) => {
  let result = [];
  for (let [key, value] of Object.entries(array)) {
    result.push({
      value: key,
      label: key,
      type: FieldType.SOURCE_DATA,
      fieldNature: TargetFieldNature.SOURCE_DATA,
      subFields: mapSourceDataOptionTargetFieldForRule(key, value, lang),
    });
  }
  return result;
};

const mapSourceDataOptionTargetFieldForRule = (sourceName, array, lang) => {
  return array.map((item) => {
    return {
      value: item.id + '',
      label:
        item.label[lang] !== undefined ? item.label[lang] : item.label['en'],
      type: FieldType.SOURCE_DATA,
      subType: item.type === 'STRING' ? FieldType.TEXT : item.type,
      valueOptions: [],
      fieldNature: TargetFieldNature.SOURCE_DATA,
      path: [sourceName, item.id + ''],
    };
  });
};

export const getTargetFieldOptionsForDocument = (properties = []) => {
  const countryList = Object.entries(getCountries(i18next.language))
      .map(([code, name]) => ({ value: code, label: name }))
      .sort((a, b) => a.label.localeCompare(b.label));
  return [
    {
      value: 'status',
      label: 'Statut 2.0',
      type: FieldType.TEXT,
      valueOptions: [
        {
          value: 'IN_PROGRESS',
          label: i18next.t(
            `viewer.status.statusLabel.${statusEngCode.IN_PROGRESS}`
          ),
        },
        {
          value: 'ACTION_REQUIRED',
          label: i18next.t(
            `viewer.status.statusLabel.${statusEngCode.ACTION_REQUIRED}`
          ),
        },
        {
          value: 'BELOW_EXPECTATION',
          label: i18next.t(
            `viewer.status.statusLabel.${statusEngCode.BELOW_EXPECTATION}`
          ),
        },
        {
          value: 'NOT_VALID',
          label: i18next.t(
            `viewer.status.statusLabel.${statusEngCode.NOT_VALID}`
          ),
        },
        {
          value: 'VALID',
          label: i18next.t(`viewer.status.statusLabel.${statusEngCode.VALID}`),
        },
        {
          value: 'MISSING',
          label: i18next.t(
            `viewer.status.statusLabel.${statusEngCode.MISSING}`
          ),
        },
      ],
      fieldNature: TargetFieldNature.STATUS,
    },
    {
      value: 'sisIdScore',
      label: 'Scores Sis ID',
      type: FieldType.TEXT,
      valueOptions: [
        {
          value: 'NO',
          label: i18next.t('sisid.classification.NO'),
        },
        {
          value: 'LOW',
          label: i18next.t('sisid.classification.LOW'),
        },
        {
          value: 'MEDIUM',
          label: i18next.t('sisid.classification.MEDIUM'),
        },
        {
          value: 'HIGH',
          label: i18next.t('sisid.classification.HIGH'),
        },
      ],
      fieldNature: TargetFieldNature.SCORE,
    },
    {
      value: 'trustPairScore',
      label: 'Scores Trustpair',
      type: FieldType.TEXT,
      valueOptions: [
        {
          value: 'favorable',
          label: i18next.t('favorable'),
        },
        {
          value: 'pending',
          label: i18next.t('pending'),
        },
        {
          value: 'unfavorable',
          label: i18next.t('unfavorable'),
        },
        {
          value: 'anomaly',
          label: i18next.t('anomaly'),
        },
        {
          value: 'unevaluated',
          label: i18next.t('unevaluated'),
        },
      ],
      fieldNature: TargetFieldNature.SCORE,
    },
    ...properties
      ?.filter((property) => {
        // Supporting a limited list of field types
        return [
          DocumentTypePropertyType.CHAINE,
          DocumentTypePropertyType.MULTILIGNES,
          DocumentTypePropertyType.EMAIL,
          DocumentTypePropertyType.TELEPHONE,
          DocumentTypePropertyType.IBAN,
          DocumentTypePropertyType.MONTANT,
          DocumentTypePropertyType.NOMBRE,
          DocumentTypePropertyType.DEVISE,
          DocumentTypePropertyType.DATE,
          DocumentTypePropertyType.RADIO_BUTTON,
          DocumentTypePropertyType.LIST_ITEM,
          DocumentTypePropertyType.CASE_A_COCHER,
          DocumentTypePropertyType.BANK_COUNTRY_CODE,
          //TODO: implement this
          //DocumentTypePropertyType.LISTE_CHOIX,

          //Not managed
          //DocumentTypePropertyType.QUESTION_TEXTAREA,
          //DocumentTypePropertyType.SIGNATURE,
          //DocumentTypePropertyType.TEXTAREA
        ].includes(property.type);
      })
      .map((property) => {
        return property?.type === DocumentTypePropertyType.BANK_COUNTRY_CODE ?
        {
          value: `${property?.id}`,
          label: i18next.t(`calculator.dialog.create.variableTarget.bankCountryCode`),
          type: FieldType.FORM_FIELD,
          subType: property?.type,
          valueOptions: countryList,
          fieldNature: TargetFieldNature.ENTITY_FIELD,
        }
        :
        {
          value: `${property?.id}`,
          label: `${property?.label}`,
          type: FieldType.FORM_FIELD,
          subType: property?.type,
          valueOptions: [
            DocumentTypePropertyType.NOMBRE,
            DocumentTypePropertyType.DATE,
          ].includes(property?.type)
            ? []
            : (property?.valueOptions?.map(option => ({
                  value: option?.label,
                  label: option?.label
              })) || []),
          fieldNature: TargetFieldNature.ENTITY_FIELD,
        };
      }),
  ];
};

export const getTargetFieldOptionsForDossier = (
  dossierAttributes = [],
  calculatedAttributes = [],
  indicators = []
) => {
  dossierAttributes = dossierAttributes.sort((a, b) =>
    a.label.localeCompare(b.label)
  );
  return [
    {
      value: 'reference',
      label: 'Référence',
      type: FieldType.TEXT,
      valueOptions: [],
      fieldNature: TargetFieldNature.ENTITY_FIELD,
    },
    {
      value: 'startDate',
      label: "Date d'ajout",
      type: FieldType.DATE,
      valueOptions: [],
      fieldNature: TargetFieldNature.ENTITY_FIELD,
    },
    {
      value: 'endDate',
      label: 'Date de fin',
      type: FieldType.DATE,
      valueOptions: [],
      fieldNature: TargetFieldNature.ENTITY_FIELD,
    },
    {
      value: 'status',
      label: 'Statut 2.0',
      type: FieldType.TEXT,
      valueOptions: [
        {
          value: 'IN_PROGRESS',
          label: i18next.t(
            `viewer.status.statusLabelDossier.${statusEngCode.IN_PROGRESS}`
          ),
        },
        {
          value: 'ACTION_REQUIRED',
          label: i18next.t(
            `viewer.status.statusLabelDossier.${statusEngCode.ACTION_REQUIRED}`
          ),
        },
        {
          value: 'NOT_VALID',
          label: i18next.t(
            `viewer.status.statusLabelDossier.${statusEngCode.NOT_VALID}`
          ),
        },
        {
          value: 'VALID',
          label: i18next.t(
            `viewer.status.statusLabelDossier.${statusEngCode.VALID}`
          ),
        },
        {
          value: 'MISSING',
          label: i18next.t(
            `viewer.status.statusLabelDossier.${statusEngCode.MISSING}`
          ),
        },
      ],
      fieldNature: TargetFieldNature.STATUS,
    },
    ...dossierAttributes
      ?.filter((attr) => {
        return ![AttributeType.STRING].includes(attr.type);
      })
      ?.map((attr) => {
        return {
          value: `${attr.id}`,
          label: attr.label,
          type: FieldType.ATTRIBUTE,
          subType: attr.type,
          dt: true,
          /*
          A boolean attribute doesn't have predefined value options on the backend side,
          but it's a primitive type that has limited options (true and false), so process
          it differently
        */
          valueOptions:
            AttributeType.BOOLEAN === attr.type
              ? [
                {
                  value: 'true',
                  label: i18next.t('yes'),
                },
                {
                  value: 'false',
                  label: i18next.t('no'),
                },
              ]
              : attr.values?.map((valueEntry) => {
                return {
                  value: valueEntry.value,
                  label: valueEntry.value,
                };
              }) || [],
          fieldNature: TargetFieldNature.ATTRIBUTE,
        };
      }),

      ...calculatedAttributes?.map((attr) => {
      return {
        value: `${attr.value}`,
        label: attr.label,
        type: FieldType.CALCULATED_ATTRIBUTE,
        subType: attr.type,
        valueOptions: [],
        fieldNature: TargetFieldNature.ATTRIBUTE,
        dt: true,
      };
    }),
    ...indicators?.map((ind) => {
      return {
        value: `${ind.value}`,
        label: ind.label,
        type: FieldType.INDICATOR,
        subType: ind.type,
        valueOptions: [],
        fieldNature: TargetFieldNature.INDICATOR,
        dt: true,
      };
    }),
  ];
};

export const getTargetFieldOptionsForContextModels = (
  contextsModels = [],
  targetFieldData
) => {
  const selectedContext = contextsModels.find((context) => {
    return context.id === targetFieldData.context_model_id;
  });
  let attributes;
  switch (targetFieldData.target_field_nature) {
    case TargetFieldNature.CONTEXT_ATTRIBUTE:
      attributes = selectedContext.contextAttributes;
      break;
    case TargetFieldNature.CONTEXT_TIERS_ATTRIBUTE:
      attributes = selectedContext.tiersAttributes;
      break;
    case TargetFieldNature.CONTEXT_DECLARANT_ATTRIBUTE:
      attributes = selectedContext.demandeAttributes;
      break;
    default:
      attributes = [];
  }
  return attributes.map((attr) => {
    return {
      value: `${attr.id}`,
      label: attr.label,
      type: FieldType.ATTRIBUTE,
      subType: attr.type,
      dt: true,
      /*
        A boolean attribute doesn't have predefined value options on the backend side,
        but it's a primitive type that has limited options (true and false), so process
        it differently
      */
      valueOptions:
        AttributeType.BOOLEAN === attr.type
          ? [
            {
              value: 'true',
              label: i18next.t('yes'),
            },
            {
              value: 'false',
              label: i18next.t('no'),
            },
          ]
          : attr.values?.map((valueEntry) => {
            return {
              value: valueEntry.value,
              label: valueEntry.value,
            };
          }) || [],
      fieldNature: targetFieldData.target_field_nature,
    };
  });
};

export const getTargetFieldOptionsForContextDirectField = () => {
  return {
    value: `rank`,
    label: '',
    type: FieldType.CONTEXT_RANK,
    subType: 'integer',
    valueOptions: [],
    fieldNature: TargetFieldNature.CONTEXT_RANK,
  };
};

export const getCriterionOperatorOptions = () => {
  return {
    TEXT: [
      {
        value: Operator.EQUAL,
        label: i18next.t('operator.equalTo'),
      },
      // {
      //     value: Operator.NOT_EQUAL,
      //     label: i18next.t("operator.notEqual"),
      // },
      {
        value: Operator.CONTAINS,
        label: i18next.t('operator.contains'),
      },
      // {
      //     value: Operator.NOT_CONTAINS,
      //     label: "Ne contient pas",
      // },
      {
        value: Operator.STARTS_WITH,
        label: i18next.t('operator.startsWith'),
      },
      // {
      //     value: Operator.NOT_STARTS_WITH,
      //     label: "Ne commence pas par",
      // },
      {
        value: Operator.ENDS_WITH,
        label: i18next.t('operator.endsWith'),
      },
      // {
      //     value: Operator.NOT_ENDS_WITH,
      //     label: "Ne se termine pas par",
      // },
      {
        value: Operator.IS_NULL,
        label: i18next.t('operator.isNull'),
      },
      {
        value: Operator.NOT_NULL,
        label: i18next.t('operator.notNull'),
      },
      {
        value: Operator.IN_SET,
        label: i18next.t('operator.inSet'),
      },
      // {
      //     value: Operator.NOT_IN_SET,
      //     label: "Ne fait pas partie de",
      // },
    ],

    NUMERIC: [
      {
        value: Operator.EQUAL,
        label: '=',
      },
      {
        value: Operator.NOT_EQUAL,
        label: '!=',
      },
      {
        value: Operator.GREATER_THAN,
        label: '>',
      },
      {
        value: Operator.GREATER_OR_EQUAL,
        label: '>=',
      },
      {
        value: Operator.LESS_THAN,
        label: '<',
      },
      {
        value: Operator.LESS_OR_EQUAL,
        label: '<=',
      },
      // {
      //     value: Operator.BETWEEN,
      //     label: "Est entre",
      // },
      {
        value: Operator.IS_NULL,
        label: i18next.t('operator.isNull'),
      },
      {
        value: Operator.NOT_NULL,
        label: i18next.t('operator.notNull'),
      },
      {
        value: Operator.IN_SET,
        label: i18next.t("operator.inSet"),
      },
      // {
      //     value: Operator.NOT_IN_SET,
      //     label: "Ne fait pas partie de"
      // }
    ],

    DATE: [
      {
        value: Operator.EQUAL,
        label: i18next.t('operator.equal'),
      },
      {
        value: Operator.NOT_EQUAL,
        label: i18next.t('operator.notEqual'),
      },
      {
        value: Operator.GREATER_THAN,
        label: i18next.t('operator.date.greaterThan'),
      },
      {
        value: Operator.GREATER_OR_EQUAL,
        label: i18next.t('operator.date.greaterOrEqual'),
      },
      {
        value: Operator.LESS_THAN,
        label: i18next.t('operator.date.lessThan'),
      },
      {
        value: Operator.LESS_OR_EQUAL,
        label: i18next.t('operator.date.lessOrEqual'),
      },
      // {
      //     value: Operator.BETWEEN,
      //     label: "Est entre",
      // },
      {
        value: Operator.IS_NULL,
        label: i18next.t('operator.isNull'),
      },
      {
        value: Operator.NOT_NULL,
        label: i18next.t('operator.notNull'),
      },
      // {
      //   value: Operator.IN_SET,
      //   label: i18next.t("operator.inSet"),
      // },
      // {
      //     value: Operator.NOT_IN_SET,
      //     label: "Ne fait pas partie de",
      // }
    ],

    BOOLEAN: [
      {
        value: Operator.EQUAL,
        label: i18next.t('operator.equal'),
      },
      {
        value: Operator.NOT_EQUAL,
        label: i18next.t('operator.notEqual'),
      },
      {
        value: Operator.IN_SET,
        label: i18next.t("operator.inSet"),
      },
      // {
      //     value: Operator.NOT_IN_SET,
      //     label: "Ne fait pas partie de"
      // }
    ],

    CUSTOM: [
      {
        value: Operator.EQUAL,
        label: i18next.t('operator.equal'),
      },
      {
        value: Operator.NOT_EQUAL,
        label: i18next.t('operator.notEqual'),
      },
      {
        value: Operator.IN_SET,
        label: i18next.t("operator.inSet"),
      },
      // {
      //     value: Operator.NOT_IN_SET,
      //     label: "Ne fait pas partie de"
      // }
    ],

    ATTRIBUTE: [
      /*For all attribute types: LIST_MULTIPLE, LIST_UNIQUE, DECIMAL, INTEGER, PERCENTAGE, BOOLEAN*/
      {
        value: Operator.EQUAL,
        label: i18next.t('operator.equalTo'),
      },
      // {
      //     value: Operator.NOT_EQUAL,
      //     label: i18next.t("operator.notEqual"),
      // },

      /*For LIST_MULTIPLE, LIST_UNIQUE, */
      {
        value: Operator.CONTAINS,
        label: i18next.t('operator.contains'),
      },
      {
        value: Operator.NOT_CONTAINS,
        label: i18next.t('operator.notContains'),
      },
      {
        value: Operator.STARTS_WITH,
        label: i18next.t('operator.startsWith'),
      },
      // {
      //     value: Operator.NOT_STARTS_WITH,
      //     label: "Ne commence pas par",
      // },
      {
        value: Operator.ENDS_WITH,
        label: i18next.t('operator.endsWith'),
      },
      // {
      //     value: Operator.NOT_ENDS_WITH,
      //     label: "Ne se termine pas par",
      // },

      /*For: DECIMAL, INTEGER, PERCENTAGE*/
      {
        value: Operator.GREATER_THAN,
        label: i18next.t("operator.greaterThan"),
      },
      {
        value: Operator.GREATER_OR_EQUAL,
        label: i18next.t("operator.greaterOrEqual"),
      },
      {
        value: Operator.LESS_THAN,
        label: i18next.t("operator.lessThan"),
      },
      {
        value: Operator.LESS_OR_EQUAL,
        label: i18next.t("operator.lessOrEqual"),
      },
      // {
      //     value: Operator.BETWEEN,
      //     label: "Est entre",
      // },

      /*For all attribute types: LIST_MULTIPLE, LIST_UNIQUE, DECIMAL, INTEGER, PERCENTAGE, BOOLEAN*/
      {
        value: Operator.IS_NULL,
        label: i18next.t('operator.isNull'),
      },

      /*For all attribute types: LIST_MULTIPLE, LIST_UNIQUE, DECIMAL, INTEGER, PERCENTAGE, BOOLEAN*/
      {
        value: Operator.NOT_NULL,
        label: i18next.t('operator.notNull'),
      },
      /*For all attribute types: LIST_MULTIPLE, LIST_UNIQUE*/
      {
        value: Operator.IN_SET,
        label: i18next.t('operator.inSet'),
      },
      {
        value: Operator.NOT_IN_SET,
        label: i18next.t('operator.notInSet'),
      },
    ],

    RISK: [
      {
        value: Operator.EQUAL, // "IS"
        label: i18next.t("operator.equal"),
      },
      {
        value: Operator.NOT_EQUAL, //"NOT"
        label: i18next.t("operator.notEqual"),
      },
      {
        value: Operator.IN_SET,
        label: i18next.t('operator.inSet'),
      },
      // {
      //     value: Operator.NOT_IN_SET, //"IS_NOT_ANY_OF"
      //     label: "Ne fait pas partie de"
      // }
      {
        value: Operator.IS_NULL, //"IS_EMPTY"
        label: i18next.t("operator.isNull"),
      },
      // {
      //   value: Operator.NOT_NULL, //"IS_NOT_EMPTY"
      //   label: i18next.t("operator.notNull"),
      // },
    ],

    CALCULATED_ATTRIBUTE: [
      {
        value: Operator.EQUAL,
        label: i18next.t('operator.equalTo'),
      },
      {
        value: Operator.CONTAINS,
        label: i18next.t('operator.contains'),
      },
      {
        value: Operator.STARTS_WITH,
        label: i18next.t('operator.startsWith'),
      },
      {
        value: Operator.ENDS_WITH,
        label: i18next.t('operator.endsWith'),
      },
      {
        value: Operator.GREATER_THAN,
        label: i18next.t("operator.greaterThan"),
      },
      {
        value: Operator.GREATER_OR_EQUAL,
        label: i18next.t("operator.greaterOrEqual"),
      },
      {
        value: Operator.LESS_THAN,
        label: i18next.t("operator.lessThan"),
      },
      {
        value: Operator.LESS_OR_EQUAL,
        label: i18next.t("operator.lessOrEqual"),
      },
      {
        value: Operator.IS_NULL,
        label: i18next.t('operator.isNull'),
      },
      {
        value: Operator.NOT_NULL,
        label: i18next.t('operator.notNull'),
      },
      {
        value: Operator.IN_SET,
        label: i18next.t('operator.inSet'),
      },
    ],

    INDICATOR: [
      {
        value: Operator.EQUAL,
        label: i18next.t('operator.equalTo'),
      },
      {
        value: Operator.CONTAINS,
        label: i18next.t('operator.contains'),
      },
      {
        value: Operator.STARTS_WITH,
        label: i18next.t('operator.startsWith'),
      },
      {
        value: Operator.ENDS_WITH,
        label: i18next.t('operator.endsWith'),
      },
      {
        value: Operator.GREATER_THAN,
        label: i18next.t("operator.greaterThan"),
      },
      {
        value: Operator.GREATER_OR_EQUAL,
        label: i18next.t("operator.greaterOrEqual"),
      },
      {
        value: Operator.LESS_THAN,
        label: i18next.t("operator.lessThan"),
      },
      {
        value: Operator.LESS_OR_EQUAL,
        label: i18next.t("operator.lessOrEqual"),
      },
      {
        value: Operator.IS_NULL,
        label: i18next.t('operator.isNull'),
      },
      {
        value: Operator.NOT_NULL,
        label: i18next.t('operator.notNull'),
      },
      {
        value: Operator.IN_SET,
        label: i18next.t('operator.inSet'),
      },
    ],

    ACTIVITY: [
      {
        value: Operator.EQUAL, // "IS"
        label: i18next.t('operator.equal'),
      },
      {
        value: Operator.NOT_EQUAL, //"NOT"
        label: i18next.t('operator.notEqual'),
      },
      {
        value: Operator.IN_SET, //"IS_ANY_OF"
        label: i18next.t('operator.inSet'),
      },
    ],

    SOURCE_DATA: [
      {
        value: Operator.EQUAL,
        label: i18next.t('operator.equalTo'),
      },
      {
        value: Operator.CONTAINS,
        label: i18next.t('operator.contains'),
      },
      {
        value: Operator.STARTS_WITH,
        label: i18next.t('operator.startsWith'),
      },
      {
        value: Operator.ENDS_WITH,
        label: i18next.t('operator.endsWith'),
      },
      {
        value: Operator.GREATER_THAN,
        label: i18next.t('operator.greaterThan'),
      },
      {
        value: Operator.GREATER_OR_EQUAL,
        label: i18next.t('operator.greaterOrEqual'),
      },
      {
        value: Operator.LESS_THAN,
        label: i18next.t('operator.lessThan'),
      },
      {
        value: Operator.LESS_OR_EQUAL,
        label: i18next.t('operator.lessOrEqual'),
      },
      {
        value: Operator.IS_NULL,
        label: i18next.t('operator.isNull'),
      },
      {
        value: Operator.NOT_NULL,
        label: i18next.t('operator.notNull'),
      },
      {
        value: Operator.IN_SET,
        label: i18next.t('operator.inSet'),
      },
    ],

    FORM_FIELD: [
      {
        value: Operator.EQUAL,
        label: i18next.t('operator.equalTo'),
      },
      {
        value: Operator.CONTAINS,
        label: i18next.t('operator.contains'),
      },
      {
        value: Operator.NOT_CONTAINS,
        label: i18next.t('operator.notContains'),
      },
      {
        value: Operator.STARTS_WITH,
        label: i18next.t('operator.startsWith'),
      },
      {
        value: Operator.ENDS_WITH,
        label: i18next.t('operator.endsWith'),
      },
      {
        value: Operator.GREATER_THAN,
        label: i18next.t("operator.greaterThan"),
      },
      {
        value: Operator.GREATER_OR_EQUAL,
        label: i18next.t("operator.greaterOrEqual"),
      },
      {
        value: Operator.LESS_THAN,
        label: i18next.t("operator.lessThan"),
      },
      {
        value: Operator.LESS_OR_EQUAL,
        label: i18next.t("operator.lessOrEqual"),
      },
      {
        value: Operator.IS_NULL,
        label: i18next.t('operator.isNull'),
      },
      {
        value: Operator.NOT_NULL,
        label: i18next.t('operator.notNull'),
      },
      {
        value: Operator.IN_SET,
        label: i18next.t('operator.inSet'),
      },
    ],
  };
};

export const getAvailableOperatorOptions = (criterionFieldEntry) => {
  let operatorOptions = [];
  if (criterionFieldEntry !== undefined) {
    const type = criterionFieldEntry.type;

    if (
      criterionFieldEntry.type === FieldType.RISK &&
      (criterionFieldEntry.subType === ThirdpartyScoreType.DATABLOCKS_ESG || criterionFieldEntry.subType === ThirdpartyScoreType.CREDITSAFE_NUMERIC) &&
      criterionFieldEntry.isNumeric === true
    ) {
      operatorOptions = getCriterionOperatorOptions()[FieldType.NUMERIC];
    } else {
      operatorOptions = getCriterionOperatorOptions()[criterionFieldEntry.type];

      /*
        In the case of an 'ATTRIBUTE' field, Operator.IN_SET and Operator.NOT_IN_SET operators are not acceptable on 'LIST_MULTIPLE' & 'BOOLEAN'.
      */
      switch (type) {
        case FieldType.ATTRIBUTE:
          switch (criterionFieldEntry.subType) {
            case AttributeType.LIST_UNIQUE:
              operatorOptions = operatorOptions.filter(
                (entry) =>
                  ![
                    Operator.GREATER_THAN,
                    Operator.GREATER_OR_EQUAL,
                    Operator.GREATER_OR_EQUAL,
                    Operator.LESS_THAN,
                    Operator.LESS_OR_EQUAL,
                    Operator.BETWEEN,
                  ].includes(entry.value)
              );

              break;

            case AttributeType.LIST_MULTIPLE:
              operatorOptions = operatorOptions.filter((entry) => ![
                Operator.STARTS_WITH,
                Operator.NOT_STARTS_WITH,
                Operator.ENDS_WITH,
                Operator.NOT_ENDS_WITH,
                Operator.GREATER_THAN,
                Operator.GREATER_OR_EQUAL,
                Operator.GREATER_OR_EQUAL,
                Operator.LESS_THAN,
                Operator.LESS_OR_EQUAL,
                Operator.BETWEEN,
                Operator.IN_SET,
                Operator.NOT_IN_SET,
              ].includes(entry.value)).map((entry) => {
                switch (entry.value) {
                  case Operator.CONTAINS:
                    return {
                      value: entry.value,
                      label: i18next.t("operator.containsAtLeast"),
                    }

                  default:
                    return entry;
                }
              });

              break;

            case AttributeType.DECIMAL:
            case AttributeType.INTEGER:
            case AttributeType.PERCENTAGE:
              operatorOptions = operatorOptions.filter(
                (entry) =>
                  ![
                    Operator.CONTAINS,
                    Operator.NOT_CONTAINS,
                    Operator.STARTS_WITH,
                    Operator.NOT_STARTS_WITH,
                    Operator.ENDS_WITH,
                    Operator.NOT_ENDS_WITH,
                  ].includes(entry.value)
              );

              break;

            case AttributeType.BOOLEAN:
              operatorOptions = operatorOptions.filter(
                (entry) =>
                  ![
                    Operator.CONTAINS,
                    Operator.NOT_CONTAINS,
                    Operator.STARTS_WITH,
                    Operator.NOT_STARTS_WITH,
                    Operator.ENDS_WITH,
                    Operator.NOT_ENDS_WITH,
                    Operator.GREATER_THAN,
                    Operator.GREATER_OR_EQUAL,
                    Operator.GREATER_OR_EQUAL,
                    Operator.LESS_THAN,
                    Operator.LESS_OR_EQUAL,
                    Operator.BETWEEN,
                    Operator.IN_SET,
                    Operator.NOT_IN_SET,
                  ].includes(entry.value)
              );
              break;

            case AttributeType.DATE:
              operatorOptions = operatorOptions
                .filter(
                  (entry) =>
                    ![
                      Operator.CONTAINS,
                      Operator.NOT_CONTAINS,
                      Operator.STARTS_WITH,
                      Operator.NOT_STARTS_WITH,
                      Operator.ENDS_WITH,
                      Operator.NOT_ENDS_WITH,
                      Operator.BETWEEN, //TODO: Add these 3 later if asked for
                      Operator.IN_SET,
                      Operator.NOT_IN_SET,
                    ].includes(entry.value)
                )
                .map((entry) => formatDateOperatorLabel(entry));
              break;

            default:
              break;
          }
          break;

        case FieldType.CALCULATED_ATTRIBUTE:
        case FieldType.INDICATOR:
        case FieldType.SOURCE_VARIABLE:
          switch (criterionFieldEntry.subType) {
            case CalculationResultType.STRING:
              operatorOptions = operatorOptions.filter(
                (entry) =>
                  ![
                    Operator.GREATER_THAN,
                    Operator.GREATER_OR_EQUAL,
                    Operator.GREATER_OR_EQUAL,
                    Operator.LESS_THAN,
                    Operator.LESS_OR_EQUAL,
                    Operator.BETWEEN,
                  ].includes(entry.value)
              );
              break;

            case CalculationResultType.ARITHMETIC_FORMULA_OUTPUT:
              operatorOptions = operatorOptions.filter(
                (entry) =>
                  ![
                    Operator.CONTAINS,
                    Operator.NOT_CONTAINS,
                    Operator.STARTS_WITH,
                    Operator.NOT_STARTS_WITH,
                    Operator.ENDS_WITH,
                    Operator.NOT_ENDS_WITH,
                  ].includes(entry.value)
              );
              break;

            case CalculationResultType.BOOLEAN:
              operatorOptions = operatorOptions.filter(
                (entry) =>
                  ![
                    Operator.CONTAINS,
                    Operator.NOT_CONTAINS,
                    Operator.STARTS_WITH,
                    Operator.NOT_STARTS_WITH,
                    Operator.ENDS_WITH,
                    Operator.NOT_ENDS_WITH,
                    Operator.GREATER_THAN,
                    Operator.GREATER_OR_EQUAL,
                    Operator.GREATER_OR_EQUAL,
                    Operator.LESS_THAN,
                    Operator.LESS_OR_EQUAL,
                    Operator.BETWEEN,
                    Operator.IN_SET,
                    Operator.NOT_IN_SET,
                  ].includes(entry.value)
              );
              break;

            default:
              break;
          }
          break;

        case FieldType.FORM_FIELD:
          switch (criterionFieldEntry.subType) {
            case DocumentTypePropertyType.CHAINE:
            case DocumentTypePropertyType.MULTILIGNES:
            case DocumentTypePropertyType.EMAIL:
            case DocumentTypePropertyType.TELEPHONE:
            case DocumentTypePropertyType.IBAN:
            case DocumentTypePropertyType.RADIO_BUTTON:
            case DocumentTypePropertyType.LIST_ITEM:
            case DocumentTypePropertyType.BANK_COUNTRY_CODE:
              operatorOptions = operatorOptions.filter(
                (entry) =>
                  ![
                    Operator.GREATER_THAN,
                    Operator.GREATER_OR_EQUAL,
                    Operator.GREATER_OR_EQUAL,
                    Operator.LESS_THAN,
                    Operator.LESS_OR_EQUAL,
                    Operator.BETWEEN,
                    Operator.NOT_CONTAINS,
                  ].includes(entry.value)
              );

              break;

            case DocumentTypePropertyType.MONTANT:
            case DocumentTypePropertyType.NOMBRE:
            case DocumentTypePropertyType.DEVISE:
              operatorOptions = operatorOptions.filter(
                (entry) =>
                  ![
                    Operator.CONTAINS,
                    Operator.NOT_CONTAINS,
                    Operator.STARTS_WITH,
                    Operator.NOT_STARTS_WITH,
                    Operator.ENDS_WITH,
                    Operator.NOT_ENDS_WITH,
                  ].includes(entry.value)
              );
              break;

            case DocumentTypePropertyType.DATE:
              operatorOptions = operatorOptions
                .filter(
                  (entry) =>
                    ![
                      Operator.CONTAINS,
                      Operator.NOT_CONTAINS,
                      Operator.STARTS_WITH,
                      Operator.NOT_STARTS_WITH,
                      Operator.ENDS_WITH,
                      Operator.NOT_ENDS_WITH,
                      Operator.BETWEEN, //TODO: Add these 3 later if asked for
                      Operator.IN_SET,
                      Operator.NOT_IN_SET,
                    ].includes(entry.value)
                )
                .map((entry) => formatDateOperatorLabel(entry));

              break;

            case DocumentTypePropertyType.CASE_A_COCHER:
              operatorOptions = operatorOptions.filter((entry) => ![
                Operator.STARTS_WITH,
                Operator.NOT_STARTS_WITH,
                Operator.ENDS_WITH,
                Operator.NOT_ENDS_WITH,
                Operator.GREATER_THAN,
                Operator.GREATER_OR_EQUAL,
                Operator.GREATER_OR_EQUAL,
                Operator.LESS_THAN,
                Operator.LESS_OR_EQUAL,
                Operator.BETWEEN,
                Operator.IN_SET,
                Operator.NOT_IN_SET,
              ].includes(entry.value)).map((entry) => {
                switch (entry.value) {
                  case Operator.CONTAINS:
                    return {
                      value: entry.value,
                      label: i18next.t("operator.containsAtLeast"),
                    }

                  default:
                    return entry;
                }
              });
              break;

            case DocumentTypePropertyType.LISTE_CHOIX:
              operatorOptions = [];
              break;

            default:
              break;
          }
          break;

        case FieldType.SOURCE_DATA:
          switch (criterionFieldEntry.subType) {
            case FieldType.TEXT:
              operatorOptions = operatorOptions.filter(
                (entry) =>
                  ![
                    Operator.GREATER_THAN,
                    Operator.GREATER_OR_EQUAL,
                    Operator.GREATER_OR_EQUAL,
                    Operator.LESS_THAN,
                    Operator.LESS_OR_EQUAL,
                    Operator.BETWEEN,
                  ].includes(entry.value)
              );
              break;

            case FieldType.NUMERIC:
              operatorOptions = operatorOptions.filter(
                (entry) =>
                  ![
                    Operator.CONTAINS,
                    Operator.NOT_CONTAINS,
                    Operator.STARTS_WITH,
                    Operator.NOT_STARTS_WITH,
                    Operator.ENDS_WITH,
                    Operator.NOT_ENDS_WITH,
                  ].includes(entry.value)
              );
              break;

            case FieldType.BOOLEAN:
              operatorOptions = operatorOptions.filter(
                (entry) =>
                  ![
                    Operator.CONTAINS,
                    Operator.NOT_CONTAINS,
                    Operator.STARTS_WITH,
                    Operator.NOT_STARTS_WITH,
                    Operator.ENDS_WITH,
                    Operator.NOT_ENDS_WITH,
                    Operator.GREATER_THAN,
                    Operator.GREATER_OR_EQUAL,
                    Operator.GREATER_OR_EQUAL,
                    Operator.LESS_THAN,
                    Operator.LESS_OR_EQUAL,
                    Operator.BETWEEN,
                    Operator.IN_SET,
                    Operator.NOT_IN_SET,
                  ].includes(entry.value)
              );
              break;

            case FieldType.DATE:
              operatorOptions = operatorOptions
                .filter(
                  (entry) =>
                    ![
                      Operator.CONTAINS,
                      Operator.NOT_CONTAINS,
                      Operator.STARTS_WITH,
                      Operator.NOT_STARTS_WITH,
                      Operator.ENDS_WITH,
                      Operator.NOT_ENDS_WITH,
                      Operator.BETWEEN, //TODO: Add these 3 later if asked for
                      Operator.IN_SET,
                      Operator.NOT_IN_SET,
                    ].includes(entry.value)
                )
                .map((entry) => formatDateOperatorLabel(entry));
              break;

            default:
              break;
          }
          break;
        case FieldType.CONTEXT_RANK:
          operatorOptions = getCriterionOperatorOptions()[
            FieldType.NUMERIC
          ].filter((entry) =>
            [
              Operator.EQUAL,
              Operator.GREATER_THAN,
              Operator.GREATER_OR_EQUAL,
              Operator.LESS_THAN,
              Operator.LESS_OR_EQUAL,
              Operator.BETWEEN,
            ].includes(entry.value)
          );
          break;
        default:
          break;
      }
    }
  }

  return operatorOptions;
};

export const getCriterionEntry = (
  field,
  conditionFieldOptionsForThirdParty
) => {
  return find(conditionFieldOptionsForThirdParty, { value: field });
};

export const formatRuleNameList = (list) => {
  let result = '';
  for (let name of list) {
    result += name + ', ';
  }
  return result.slice(0, -2);
};

export const mapRulesCriteria = (criteria) => {
  // Map date criteria values from moment to iso date
  return criteria?.map((criterion) => {
    if (moment.isMoment(criterion.values?.[0])) {
      criterion.values = criterion.values.map((d) =>
        moment(d).format(EDGE_DATE_FORMAT)
      );
    }

    return criterion;
  });
};

export const formatDateOperatorLabel = (attributeOp) => {
  let operator = {
    value: attributeOp.value,
  };

  switch (attributeOp.value) {
    case Operator.EQUAL:
      operator.label = i18next.t('operator.equal');
      break;
    case Operator.NOT_EQUAL:
      operator.label = i18next.t('operator.notEqual');
      break;
    case Operator.GREATER_THAN:
      operator.label = i18next.t('operator.date.greaterThan');
      break;
    case Operator.GREATER_OR_EQUAL:
      operator.label = i18next.t('operator.date.greaterOrEqual');
      break;
    case Operator.LESS_THAN:
      operator.label = i18next.t('operator.date.lessThan');
      break;
    case Operator.LESS_OR_EQUAL:
      operator.label = i18next.t('operator.date.lessOrEqual');
      break;
    case Operator.IS_NULL:
      operator.label = i18next.t('operator.isNull');
      break;
    case Operator.NOT_NULL:
      operator.label = i18next.t('operator.notNull');
      break;
    default:
      operator.label = attributeOp.label;
      break;
  }

  return operator;
};

export const getAvailableTargetFieldNatureOptions = (
  targetFieldCategory,
  hasOptionSubscription
) => {
  const targetFieldCategoryOptions = getTargetFieldNatureOptions(
    hasOptionSubscription
  )[targetFieldCategory];

  return targetFieldCategoryOptions || [];
};

export const getTargetFieldNatureOptions = (
  hasOptionSubscription = () => false
) => {
  return {
    THIRD_PARTY: [
      {
        value: TargetFieldNature.ENTITY_FIELD,
        label: i18next.t(
          `rules.configuration.criteria.targetFieldNature.${TargetFieldCategory.THIRD_PARTY}.${TargetFieldNature.ENTITY_FIELD}`
        ),
      },
      {
        value: TargetFieldNature.ATTRIBUTE,
        label: i18next.t(
          `rules.configuration.criteria.targetFieldNature.${TargetFieldCategory.THIRD_PARTY}.${TargetFieldNature.ATTRIBUTE}`
        ),
      },
      {
        value: TargetFieldNature.INDICATOR,
        label: i18next.t(
          `rules.configuration.criteria.targetFieldNature.${TargetFieldCategory.THIRD_PARTY}.${TargetFieldNature.INDICATOR}`
        ),
      },
      {
        value: TargetFieldNature.USER_INSTANCE,
        label: i18next.t(
          `rules.configuration.criteria.targetFieldNature.${TargetFieldCategory.THIRD_PARTY}.${TargetFieldNature.USER_INSTANCE}`
        ),
      },
      ...(hasOptionSubscription('DATA_HUB')
        ? [
          {
            value: TargetFieldNature.SOURCE_DATA,
            label: i18next.t(
              `rules.configuration.criteria.targetFieldNature.${TargetFieldCategory.THIRD_PARTY}.${TargetFieldNature.SOURCE_DATA}`
            ),
          },
        ]
        : []),
    ],
    CONTEXT: [
      {
        value: TargetFieldNature.CONTEXT_ATTRIBUTE,
        label: i18next.t(
          `rules.configuration.criteria.targetFieldNature.${TargetFieldCategory.CONTEXT}.${TargetFieldNature.CONTEXT_ATTRIBUTE}`
        ),
      },
      {
        value: TargetFieldNature.CONTEXT_TIERS_ATTRIBUTE,
        label: i18next.t(
          `rules.configuration.criteria.targetFieldNature.${TargetFieldCategory.CONTEXT}.${TargetFieldNature.CONTEXT_TIERS_ATTRIBUTE}`
        ),
      },
      {
        value: TargetFieldNature.CONTEXT_DECLARANT_ATTRIBUTE,
        label: i18next.t(
          `rules.configuration.criteria.targetFieldNature.${TargetFieldCategory.CONTEXT}.${TargetFieldNature.CONTEXT_DECLARANT_ATTRIBUTE}`
        ),
      },
      {
        value: TargetFieldNature.CONTEXT_RANK,
        label: i18next.t(
          `rules.configuration.criteria.targetFieldNature.${TargetFieldCategory.CONTEXT}.${TargetFieldNature.CONTEXT_RANK}`
        ),
      },
    ],
  };
};

export const parseTargetFieldFromCriterion = (criterion) => {
  const targetFieldCategory = criterion?.targetField?.target_field_category;
  let targetField = undefined;

  switch (targetFieldCategory) {
    case TargetFieldCategory.THIRD_PARTY:
      targetField =
        criterion?.targetField?.target_field_data?.data_for_third_party?.field;
      break;

    case TargetFieldCategory.DOSSIER:
      targetField =
        criterion?.targetField?.target_field_data?.data_for_dossier?.field;
      break;

    case TargetFieldCategory.DOCUMENT:
      targetField =
        criterion?.targetField?.target_field_data?.data_for_document?.field;
      break;

    case TargetFieldCategory.SOURCE_VARIABLE:
      targetField =
        criterion?.targetField?.target_field_data?.data_for_source_variable
          ?.field;
      break;
    case TargetFieldCategory.CONTEXT:
      targetField =
        criterion?.targetField?.target_field_data?.data_for_context?.field;
      break;
    default:
      break;
  }

  return targetField;
};

export const parseTargetFieldCategoryFromCriterion = (criterion) => {
  return criterion?.targetField?.target_field_category;
};

export const parseDocumentTypeIdFromCriterion = (criterion) => {
  const targetFieldCategory = criterion?.targetField?.target_field_category;
  let documentTypeId = undefined;

  switch (targetFieldCategory) {
    case TargetFieldCategory.DOCUMENT:
      documentTypeId =
        criterion?.targetField?.target_field_data?.data_for_document
          ?.document_type_id;
      break;

    default:
      break;
  }

  return documentTypeId;
};

export const parseDossierTypeIdFromCriterion = (criterion) => {
  const targetFieldCategory = criterion?.targetField?.target_field_category;
  let dossierTypeId = undefined;

  switch (targetFieldCategory) {
    case TargetFieldCategory.DOSSIER:
      dossierTypeId =
        criterion?.targetField?.target_field_data?.data_for_dossier
          ?.dossier_type_id;
      break;

    default:
      break;
  }

  return dossierTypeId;
};

export const getOrderedOptions = (options) => {
  return options ? options.sort((a, b) => a.label.localeCompare(b.label)) : [];
};
